import {
  extractQuestionnaireId,
  getSelectedQuestionTexts,
} from '@seek/rr-caja';
import { useLanguage } from '@vocab/react';
import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { getRoleRequirementsConfig } from 'src/app/utils/getRoleRequirementsConfig';
import { log } from 'src/app/utils/logging';
import { actionUpdateSelectedRRQuestions } from 'src/app/v1/state/modules/session/selectedRRQuestions';
import type { AppState } from 'src/types/appState';

export const useSelectedRRQuestions = () => {
  const { advertiserId, questionnaireUrl } = useSelector(
    (state: AppState) => ({
      advertiserId: state.session.advertiserId,
      questionnaireUrl: state.formData.questionnaireUrl,
    }),
    shallowEqual,
  );
  const dispatch = useDispatch();
  const { language } = useLanguage();

  useEffect(() => {
    const getSelectedQuestionsFromRoleReq = async (questionnaireId: string) => {
      const roleRequirementsConfig = getRoleRequirementsConfig(
        advertiserId,
        language,
      );
      try {
        const questions = await getSelectedQuestionTexts(
          questionnaireId,
          roleRequirementsConfig,
        );

        dispatch(actionUpdateSelectedRRQuestions(questions));
      } catch {
        log.error(
          'Unable to retrieve selected questions from Role Requirement API',
          {
            advertiserId,
            questionnaireId,
            questionnaireUrl,
          },
        );
      }
    };

    if (questionnaireUrl) {
      const questionnaireId = extractQuestionnaireId(questionnaireUrl);

      if (questionnaireId) {
        getSelectedQuestionsFromRoleReq(questionnaireId);
      }
    }
  }, [advertiserId, dispatch, questionnaireUrl, language]);
};
